import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

// Loud, non-dismissible banner shown ONLY when the live Stripe platform account (STRIPE_ACCOUNT_ID)
// drifts from the known-good OpticSwap account — the recurring "sandbox reinjection" incident that
// silently breaks seller payouts. Polls every 60s so it clears itself after a good redeploy.
export const StripeGuardBanner = () => {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    let alive = true;
    const load = () =>
      api
        .get("/admin/stripe-account-guard")
        .then(({ data }) => { if (alive) setStatus(data); })
        .catch(() => {});
    load();
    const id = setInterval(load, 60000);
    return () => { alive = false; clearInterval(id); };
  }, []);

  if (!status || status.ok) return null;

  return (
    <div
      role="alert"
      data-testid="stripe-guard-banner"
      className="flex items-start gap-3 border-b-2 border-red-500 bg-red-950/70 px-4 md:px-8 py-3 text-red-50"
    >
      <AlertTriangle className="h-5 w-5 shrink-0 mt-0.5 text-red-400" strokeWidth={2} aria-hidden="true" />
      <div className="min-w-0">
        <p className="font-heading text-sm font-bold uppercase tracking-wide" data-testid="stripe-guard-banner-title">
          Payouts disabled — Stripe platform account mismatch
        </p>
        <p className="mt-0.5 text-xs leading-relaxed text-red-100/90" data-testid="stripe-guard-banner-message">
          {status.message}
        </p>
        <p className="mt-1 font-mono text-[11px] text-red-200/80" data-testid="stripe-guard-banner-detail">
          expected {status.expected_masked || "—"} · configured {status.configured_masked || "(empty)"}
        </p>
      </div>
    </div>
  );
};
